export class Box {
    length?:number;
    width?:number;
    height?:number;

    public constructor(params:Box = {} as Box){
        let {
            length = 0,
            width = 0,
            height = 0
        } = params;
        this.length = length;
        this.width = width;
        this.height = height;
    }

    public SetSize(l:number,w:number,h:number):void{
        this.length = l;
        this.width = w;
        this.height = h;
    }
}